module.exports = __webpack_public_path__ + "static/img/uz.a7acab2c.svg";